import { FILTER_STATUS_RESOLVED } from './constants';

export const REGISTER_FILTER = 'REGISTER_FILTER';
export const UNREGISTER_FILTER = 'UNREGISTER_FILTER';
export const SET_FILTER_TOUCHED = 'SET_FILTER_TOUCHED';
export const SET_FILTER_STATUS = 'SET_FILTER_STATUS';
export const SET_FILTER_INFLUENCE_STATUS = 'SET_FILTER_INFLUENCE_STATUS';

export const defaultDataState = {};

const dataReducer = (state, action) => {
  switch (action.type) {
    case REGISTER_FILTER: {
      const registerFilter = state[action.payload.path];

      return {
        ...state,
        ...action.payload.depends?.reduce((acc, path) => {
          const influences = acc[path]?.influences || [];

          return {
            ...acc,
            [path]: {
              ...acc[path],
              influences: [
                ...influences,
                ...(influences?.includes(action.payload.path)
                  ? []
                  : [action.payload.path]),
              ],
            },
          };
        }, state),
        [action.payload.path]: {
          influences: [],
          status: FILTER_STATUS_RESOLVED,
          touched: false,
          ...registerFilter,
          depends: action.payload.depends,
          _count:
            registerFilter?._count === undefined
              ? 1
              : registerFilter._count + 1,
        },
      };
    }

    case UNREGISTER_FILTER: {
      const { _count: count, ...unregisterFilter } = state[action.payload.path];

      if (count > 1) {
        return {
          ...state,
          [action.payload.path]: {
            ...unregisterFilter,
            _count: count - 1,
          },
        };
      }

      const { [action.payload.path]: _, ...stateWithoutUnregisterFilter } =
        state;

      return {
        ...stateWithoutUnregisterFilter,
        ...action.payload.depends?.reduce(
          (acc, path) => ({
            ...acc,
            [path]: {
              ...acc[path],
              influences: acc[path].filter(
                (item) => item !== action.payload.path
              ),
            },
          }),
          stateWithoutUnregisterFilter
        ),
      };
    }

    case SET_FILTER_TOUCHED:
      return {
        ...state,
        [action.payload.path]: {
          ...state[action.payload.path],
          touched: true,
        },
      };

    case SET_FILTER_STATUS:
      return {
        ...state,
        [action.payload.path]: {
          ...state[action.payload.path],
          status: action.payload.status,
        },
      };

    case SET_FILTER_INFLUENCE_STATUS:
      return {
        ...state,
        ...state[action.payload.path]?.influences.reduce((acc, item) => {
          const influencedItem = acc[item];

          if (!influencedItem) {
            return acc;
          }

          return {
            ...acc,
            [item]: {
              ...influencedItem,
              status: influencedItem.touched
                ? action.payload.status
                : influencedItem.status,
            },
          };
        }, state),
      };

    default:
      return state;
  }
};

export default dataReducer;
